var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-modal',{staticClass:"om-custom-integrations-modal integration",attrs:{"name":"custom-integrations","width":881}},[_c('modals-header',{attrs:{"name":"custom-integrations"}}),_c('integrations-partials-custom-integrations'),_c('modals-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }